import { useState, useLayoutEffect, useEffect } from 'react';

const useEffectOrLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
const isServer = typeof window === 'undefined';

export function useWindowSize() {
  const [size, setSize] = useState([1280, 0]);

  function updateSize() {
    if (!isServer) setSize([window.innerWidth, window.innerHeight]);
  }

  useEffectOrLayoutEffect(() => {
    if (!isServer) {
      window.addEventListener('resize', updateSize, { passive: true });
      updateSize();

      return () => window.removeEventListener('resize', updateSize, { passive: true });
    }
    return null;
  }, [useEffectOrLayoutEffect]);

  return size;
}

export default useWindowSize;
